(() => {
  if (customElements.get('memys-product-whatsapp')) return;
  customElements.define('memys-product-whatsapp', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true; this.controller = new AbortController();
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.querySelector('a').addEventListener('click', event => {
        const form = document.getElementById(this.dataset.formId);
        const input = form?.querySelector('[name="quantity"]');
        const quantity = input ? Number(input.value) : 1;
        const error = this.querySelector('[data-error]');
        if (!Number.isInteger(quantity) || quantity < 1 || input && !input.checkValidity()) { event.preventDefault(); error.hidden = false; input?.reportValidity(); return; }
        error.hidden = true;
        const id = form?.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(v => String(v.id) === String(id));
        const url = new URL(this.dataset.url);
        if (id && /^\d+$/.test(id)) url.searchParams.set('variant', id);
        const lines = [this.labels.intro, `${this.labels.product} ${this.dataset.title}`];
        if (variant?.title && variant.title !== 'Default Title') lines.push(`${this.labels.variant} ${variant.title}`);
        lines.push(`${this.labels.quantity} ${quantity}`, url.href);
        event.currentTarget.href = `https://wa.me/${this.dataset.phone}?text=${encodeURIComponent(lines.join('\n'))}`;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
  });
})();

